import React, { useState, useRef } from "react";
import DataGrid, {
  Column,
  Pager,
  Paging,

  Selection,
  Editing,
  Grouping,
  GroupPanel,
  Export,
  Sorting,
  Toolbar,
  Item,
  ColumnChooser,
  Scrolling,
  MasterDetail
} from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { capitalizeWords, onExportingExcelQCP } from "utils/helpers";
import { useDispatch, useSelector } from "react-redux";
import CheckBox from "devextreme-react/check-box"; // Assuming DevExtreme
import { useNavigate } from "react-router-dom";
import QCP_API from "api/qcpApi";
import { apiGet } from "api/api-qcp";
import { useDelete } from "@hooks/useQcpApi";
import notify from "devextreme/ui/notify";
import { confirm } from "devextreme/ui/dialog"; // Import confirm from DevExtreme
import { useQueryClient } from "@tanstack/react-query";
import Accordion from 'devextreme-react/accordion';
import { Button } from "devextreme-react/button";
import RadioGroup from 'devextreme-react/radio-group';
import { FileUploader } from "devextreme-react/file-uploader";
import { TextArea } from "devextreme-react/text-area";
import { TextBox } from "devextreme-react/text-box";
import { SelectBox } from "devextreme-react";
import EditQCP from "./EditQCP";
import EditQCPTest2 from "./EditQCPTest2";

const exportFormats = ["xlsx"];

export default function QCPTable({ onExpand, isExpanded }) {
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const navigate = useNavigate();
  const batchID = useSelector((state) => state.overview.batchId)
  const deleteMutation = useDelete("deleteQCP", QCP_API.getQCPListing);
  const [selectedBatchId, setSelectedBatchId] = useState([]);
  const gridRef = useRef(null);
  const [selectedFiles, setSelectedFiles] = useState([]); // Store selected files
  const [uploadedFiles, setUploadedFiles] = useState([]); // Store uploaded file objects with statuses
  const currentDate = new Date().toISOString(); // Store ISO format for consistency
  const [comments, setComments] = useState([]); // Store comments
  const [newComment, setNewComment] = useState(""); // Track input
  const [sortSelected, setSortSelected] = useState(false);
  const [fileUploaderKey, setFileUploaderKey] = useState(0);
  const [editStates, setEditStates] = useState({}); // Manage edit states for each record

  const toggleEditState = (id) => {
    setEditStates((prev) => ({
      ...prev,
      [id]: !prev[id], // Toggle the edit state for the specific record
    }));
  };

  const handleFileChange = (e) => {
    const files = e.value;
    const filePreviews = files.map((file) => ({
      name: file.name,
      size: file.size, // Include file size
      url: URL.createObjectURL(file), // Generate a preview URL for the file
      status: "pending", // Initial status
    }));

    setSelectedFiles(files); // Store selected files for upload
    setUploadedFiles(filePreviews); // Update preview list
  };

  const handleDeleteImage = (index) => {
    setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
    setSelectedFiles((prev) => {
      const updated = prev.filter((_, i) => i !== index);
      setFileUploaderKey((k) => k + 1); // force FileUploader to re-render
      return updated;
    });
  };

  const handleAddComment = () => {
    if (newComment.trim() !== "") {
      const updatedComments = [...comments, { commentText: newComment }];
      setComments(updatedComments);
      setNewComment(""); // Clear input
    }
  };


  const handleDeleteComment = (commentIndex) => {
    const updatedComments = comments.filter((_, index) => index !== commentIndex);
    setComments(updatedComments);
  };



  const onSelectionChanged = async (e) => {


    const selectedData = await e.component.getVisibleRows();
    const keys = await e.component.getSelectedRowKeys();
    console.log(await e.component.getSelectedRowKeys(), "selected rows");

  };


  // Show the expended data on collapse arrow click in each record in the table

  // const collapseDetail = ({ data }) => {
  //   return (
  //     <div className="p-4 bg-gray-100 border rounded dark-bg">
  //       <p><strong>Box Temp:</strong> {data?.boxData?.temp} °C</p>
  //       <p><strong>Approved By:</strong> {data?.approvedBy}</p>
  //       <p><strong>Inspected By:</strong> {data?.inspectedBy}</p>
  //     </div>
  //   );
  // };
  const collapseDetail = ({ data }) => { // Pass the record's data

    const accordionItems = data.qcpTests.map((test, index) => ({
      title: test?.type === 1 ? "Fish Intake Control" : "Fillet Control 100", // Set title based on type
      content: (
        <div>
          {test?.type === 1 ? (
            <EditQCP id={test?.qcP_ID} /> // Render EditQCP if type is 1
          ) : (
            <EditQCPTest2 id={test?.qcP_ID} /> // Render EditQCPTest2 if type is 2
          )}
        </div>
      ),
    }));

    return (
      <Accordion
        items={accordionItems}
        itemTitleRender={(item) => item.title}
        itemRender={(item) => item.content}
        collapsible={true}
        multiple={true}
      />
    );
  };


  // ✅ Function to trigger API call
  const sendSelectedIds = async () => {
    const selected = gridRef.current.instance().getSelectedRowsData();

    if (selected?.length === 0) {
      notify({
        message: "No rows selected for deletion",
        type: "error",
        displayTime: 2000,
        position: {
          my: "top right",
          at: "top right",
          of: window,
        },
      });
      return;
    }

    const result = await confirm("Are you sure you want to delete the selected Record?", "Confirm Deletion");
    if (result) {
      try {
        for (const item of selected) {
          for (const test of item.qcpTests) {
            console.log("test", test.qcP_ID);

            await deleteMutation.mutateAsync({ QCPIds: [test.qcP_ID] }); // Call API for each nested object
          }
        }
        console.log("Successfully deleted selected IDs:", selected);
        notify({
          message: "Selected rows deleted successfully",
          type: "success",
          displayTime: 2000,
          position: {
            my: "top right",
            at: "top right",
            of: window,
          },
        });
        // ✅ Refresh DataGrid after deletion
        // dataSource.load();
      } catch (error) {
        console.error("Error deleting selected IDs:", error);
        notify({
          message: "Error deleting selected rows",
          type: "error",
          displayTime: 2000,
          position: {
            my: "top right",
            at: "top right",
            of: window,
          },
        });
      }
    }
  };
  const queryClient = useQueryClient(); // ✅ Import from 'react-query'
  const dataSource = new CustomStore({
    key: "qcP_ID",
    load: async (loadOptions) => {
      const take = loadOptions.take || pageSize;
      const skip = loadOptions.skip || 0;
      const pageNo = Math.floor(skip / take); // ✅ Start page numbering from 0

      try {
        const response = await queryClient.fetchQuery({
          queryKey: ["qcpList", pageNo, pageSize],
          queryFn: () =>
            apiGet(QCP_API.getQCPListing, {
              PageNo: pageNo,
              PageSize: pageSize,
            }),
        });

        console.log("API Response:", response); // ✅ Debug API response
        let qcpdata = response?.data;
        const totalRecords = response?.info?.totalRecordsCount || 0; // ✅ Ensure totalRecords is retrieved

        // Generate qcP_ID based on qcpTests
        qcpdata = qcpdata.map((item) => ({
          ...item,
          qcP_ID: item.qcpTests
            ? item.qcpTests.map((test) => test.qcP_ID).join("-") // Combine qcP_IDs with a delimiter
            : null, // Handle cases where qcpTests is empty or undefined
        }));

        // qcpdata = qcpdata.sort((a, b) => {
        //   if (a.batchNo < b.batchNo) return -1; // Sort in ascending order by batchNo
        //   if (a.batchNo > b.batchNo) return 1;
        //   return 0;
        // });

        if (sortSelected && loadOptions.sort?.length > 0) {
          const { selector, desc } = loadOptions.sort[0];
          qcpdata.sort((a, b) => {
            const aValue = a[selector];
            const bValue = b[selector];

            if (aValue < bValue) return desc ? 1 : -1;
            if (aValue > bValue) return desc ? -1 : 1;

            return 0;
          });
        }

        setTotalCount(totalRecords); // ✅ Set totalCount from API response
        return {
          data: qcpdata,
          totalCount: totalRecords, // ✅ Ensure totalCount is returned
        };
      } catch (error) {
        console.error("Error loading data:", error);
        throw error;
      }
    },
    update: async (key, values) => {
      console.log("Updating:", key, values);
    },
  });

  const handleExportSelected = (e) => {
    const selected = [...new Set(gridRef.current.instance().getSelectedRowKeys())]; // Ensure unique selected IDs
    console.log("Export event:", selected);

    // Only export if selected rows exist
    if (e.format === "xlsx" || e.format === "pdf") {
      if (e.selectedRowsOnly && selected.length === 0) {
        // Show a message if no rows are selected
        notify({
          message: "Please select at least one row before exporting",
          type: "error",
          displayTime: 2000,
          position: {
            my: "top right",
            at: "top right",
            of: window,
          },
        });
        e.cancel = true; // Prevent export
        return;
      }
      // Call the appropriate export function
      if (e.format === "xlsx") {
        onExportingExcelQCP({ ...e, selectedRows: selected });
      }
    }
  };

  const CheckboxEditor = ({ value = false, onValueChanged }) => {
    const [checked, setChecked] = useState(Boolean(value));

    const handleChange = (e) => {
      const newValue = e.value;
      setChecked(newValue); // Update local state
      if (typeof onValueChanged === "function") {
        onValueChanged(newValue); // Notify parent
      }
    };

    return <CheckBox value={checked} onValueChanged={handleChange} />;
  };

  return (
    <React.Fragment>
      <p className='font-medium text-xl flex justify-center '>Box Inspect Test</p>

      <DataGrid
        className="dx-card content-block border-0"
        dataSource={dataSource}
        keyExpr="qcP_ID"
        showBorders={false}
        columnAutoWidth={true}
        columnHidingEnabled={true}
        hoverStateEnabled={true}
        rowDragging={{ allowReordering: false, showDragIcons: false }}
        ref={gridRef}
        remoteOperations={{
          paging: true,
          sorting: true, // ✅ Enable sorting for better remote operations
        }}
        loadPanel={{
          enabled: true,
          text: "Processing...",
           showIndicator: false,
          //  shading: true,
          shadingColor: "rgba(255, 255, 255, 0.7)",
        }}     
        totalCount={totalCount} // ✅ Pass totalCount to DataGrid
        rowAlternationEnabled={true}
        allowColumnReordering={true}
        searchPanel={{ visible: true, highlightCaseSensitive: true }}  // Enable search panel here
        onExporting={handleExportSelected}
        onSelectionChanged={onSelectionChanged} // ✅ Capture selection changes
        showSortIndexes={false} // ✅ Disable sort indexes in column headers
        onOptionChanged={(e) => {
          if (e.fullName === "paging.pageSize") {
            setPageSize(e.value);
          }
          if (e.value === "asc" || e.value === "desc") {
            setSortSelected(true); // Set sortSelected to true when sorting changes
          }
        }}
        onContentReady={(e) => {
          console.log("DataGrid Content Ready:", e.component.getDataSource().totalCount()); // ✅ Debug totalCount
        }}
        onRowClick={(e) => {
          if (!e.event.target.closest(".dx-checkbox")) {
            // navigate(`/quality/fillet/ccp/view/${e.data.id}`);
          }
        }}
      >

        <Scrolling mode="standard" />
        <Paging enabled={true} pageSize={pageSize} />
        <Pager
          visible={totalCount > 10}
          showPageSizeSelector={true}
          allowedPageSizes={[10, 20, 50]}
          showInfo={true}
          showNavigationButtons={true}
        />

        <Selection
          mode="multiple"
          selectAllMode="page" // or "allPages" if needed
          showCheckBoxesMode="always" // or "always"
          deferred={false} //
        />
        <GroupPanel visible={true} />
        <Grouping autoExpandAll={true} />
        <Export enabled={true} formats={exportFormats} allowExportSelectedData={true} />
        <Editing mode="row" allowUpdating={true} allowDeleting={true} />
        <ColumnChooser enabled={true} />
        <Sorting mode="multiple" showSortIndexes={false} /> {/* ✅ Ensure sorting arrows are always visible */}


        {/* <Column dataField="id" caption="Test" /> */}
        <Column dataField="batchNo" caption="Batch Num." sortOrder="asc"
          allowSorting={true} />
        <Column dataField="boxNo" caption="Box Num." sortOrder="asc"
          allowSorting={true} />
        {/* <Column
          dataField="approvedBy"
          caption="Approved By"
          sortOrder="desc"
          allowSorting={true}
          calculateCellValue={(data) => capitalizeWords(data.approvedBy)}

        />
        <Column
          dataField="inspectedBy"
          caption="Inspected By"
          sortOrder="desc"
          allowSorting={true}
          calculateCellValue={(data) => capitalizeWords(data.inspectedBy)}

        /> */}
        {/* <Column
          dataField="boxData.boxData.temp"
          caption="Temperature"
          alignment="left"
          // sortOrder="desc"
          allowSorting={false}
          calculateCellValue={(data) => `${data.boxData?.temp || ''} °C`} // Add °C to temperature
        /> */}

        {/* <Column
          caption="Status"
          dataField="status.description"
          alignment="left"
          sortOrder="desc"
          allowSorting={false}
          cellRender={(data) => {
            const status = data?.value;
            let bgColor = "";

            switch (status?.toLowerCase()) {
              case "completed":
                bgColor = "bg-green-300";
                break;
              case "on hold":
                bgColor = "bg-gray-300";
                break;
              case "inprogess":
                bgColor = "bg-yellow-300";
                break;
              case "new":
                bgColor = "bg-blue-300";
                break;
              default:
                bgColor = "bg-white";
            }

            return (
              <div className={`p-2 w-28 text-center rounded text-black ${bgColor}`}>
                {status}
              </div>
            );
          }}
        /> */}

        <Column
          caption="Action"
          type="buttons"
          allowSorting={true}
          visible={false}
          buttons={[]} // Remove the "Edit" button from the column
        />
        <Column caption="Action" width={100} cellRender={(data) => (
          <div className="flex gap-2 justify-center">
            <i
              onClick={() => navigate(`/quality/fillet/qcp/view/overview/?batchNum=${data?.data?.batchNo}&boxNum=${data?.data?.boxNo}`)}
              className="ri-eye-line cursor-pointer">
            </i>
          </div>
        )} />
        <Toolbar>

          <Item name="searchPanel" location="before" />
          <Item
            location="center"
            render={() => (
              <div className="lg:grid grid-cols-3 gap-2 hidden">
                <div>
                  Total Records:{" "}
                  <span className="font-medium">{totalCount}</span>
                </div>
              </div>
            )}
          />
          <Item widget="dxButton" onClick={() => { navigate("/quality/fillet/qcp/add") }} options={{ icon: "add", text: "", hint: "Add New Record" }} location="after" />
          <Item widget="dxButton" onClick={sendSelectedIds} options={{ icon: "trash", text: "", hint: "Delete Selected Record" }} location="after" />
          {/* <Item
            widget="dxButton"
            onClick={() => {
              const selectedRow = gridRef.current.instance().getSelectedRowsData()[0];
              let totalSelected = gridRef.current.instance().getSelectedRowKeys();
              if (totalSelected?.length > 1) {
                notify({
                  message: "Please select only one row to edit",
                  type: "error",
                  displayTime: 2000,
                  position: {
                    my: "top right",
                    at: "top right",
                    of: window,
                  },
                });
                return;
              }
              if (selectedRow) {
                navigate(`/quality/fillet/qcp/edit/${selectedRow?.qcP_ID}`, {
                  state: selectedRow,
                });
              } else {
                notify({
                  message: "Please select a row to edit",
                  type: "error",
                  displayTime: 2000,
                  position: {
                    my: "top right",
                    at: "top right",
                    of: window,
                  },
                });
              }
            }}
            options={{ icon: "edit", text: "", hint: "Edit Selected Record" }}
            location="after"
          /> */}
          <Item name="exportButton" showText="always" options={{ hint: "Export" }} />
        </Toolbar>

        {/* table row collapse */}
        <MasterDetail
          enabled={true}
          render={collapseDetail}
        />

      </DataGrid>
    </React.Fragment>
  );
}




